import React from 'react';
import { Box, TextField, InputAdornment, IconButton, Tooltip } from '@mui/material';
import { Search as SearchIcon, Close as CloseIcon, Refresh as RefreshIcon } from '@mui/icons-material';
import { color } from '../../theme/tokens';

/**
 * Filter bar: debounced-friendly search field plus slotted filters and a
 * refresh action. Pages own the state and pass handlers in.
 */
const Toolbar = ({
  search,
  onSearch,
  searchPlaceholder = 'Search…',
  children,
  onRefresh,
  refreshing = false,
  sx,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: 1.5,
      ...sx,
    }}
  >
    {onSearch && (
      <TextField
        value={search}
        onChange={(e) => onSearch(e.target.value)}
        placeholder={searchPlaceholder}
        size="small"
        sx={{ width: { xs: '100%', sm: 300 }, flexShrink: 0 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ fontSize: 18, color: color.ink[400] }} />
            </InputAdornment>
          ),
          endAdornment: search ? (
            <InputAdornment position="end">
              <IconButton size="small" onClick={() => onSearch('')} aria-label="Clear search">
                <CloseIcon sx={{ fontSize: 16 }} />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
      />
    )}

    {children}

    {onRefresh && (
      <Tooltip title="Refresh">
        <span style={{ marginLeft: 'auto' }}>
          <IconButton onClick={onRefresh} disabled={refreshing} aria-label="Refresh">
            <RefreshIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    )}
  </Box>
);

export default Toolbar;
